(function($) {
    "use strict";

    $.fn.jPushMenu = function(customOptions) {
        var o = $.extend({}, $.fn.jPushMenu.defaultOptions, customOptions);

        function internalStopPropagation(e){
            e.stopPropagation();
        }

        function internalClose(){
            $(".jPushMenuBtn,body,.cbp-spmenu").removeClass("disabled active cbp-spmenu-open cbp-spmenu-push-toleft cbp-spmenu-push-toright");
            $("div.modal-backdrop.jPushMenu-mobile-menu-visible").remove();
            $(document).off("click", internalClose);
        }

        $("body").addClass(o.bodyClass);
        $(this).addClass("jPushMenuBtn");

        $(this).click(function () {
            var target = "",
            pushDirection = "";
            if($(this).is("." + o.showLeftClass)) {
                target = ".cbp-spmenu-left";
                pushDirection = "toright";
            }
            else if($(this).is("." + o.showRightClass)) {
                target = ".cbp-spmenu-right";
                pushDirection = "toleft";
            }
            else if($(this).is("." + o.showTopClass)) {
                target = ".cbp-spmenu-top";
            }
            else if($(this).is("." + o.showBottomClass)) {
                target = ".cbp-spmenu-bottom";
            }

            $(this).toggleClass(o.activeClass);
            $(target).toggleClass(o.menuOpenClass);

            if($(this).is("." + o.pushBodyClass)) {
                $("body").toggleClass( "cbp-spmenu-push-" + pushDirection );
            }

            /* disable all other button*/
            $(".jPushMenuBtn").not($(this)).toggleClass("disabled");

            //Show the backdrop
            if ($("div.modal-backdrop.jPushMenu-mobile-menu-visible").length > 0) {
                $("div.modal-backdrop.jPushMenu-mobile-menu-visible").remove();
            }
            else {
                $("<div class=\"modal-backdrop fade in jPushMenu-mobile-menu-visible cbp-spmenu-backdrop visible-xs visible-sm\"></div>")
                    .appendTo(document.body)
                    .fadeIn();
            }
            //attach event handlers

            if(o.closeOnClickOutside) {
                $(document).on("click", internalClose);
            }

            return false;
        });


		// Close menu on clicking menu link
		$(".navbar-collapse").on("click", "a", function() {
			internalClose();
		});

        if(o.closeOnClickOutside){
            $(".cbp-spmenu,.toggle-menu").on("click", internalStopPropagation);
        }

        return this;
    };

    /* in case you want to customize class name,
     *  do not directly edit here, use function parameter when call jPushMenu.
     */
    $.fn.jPushMenu.defaultOptions = {
        bodyClass: "cbp-spmenu-push",
        activeClass: "menu-active",
        showLeftClass: "menu-left",
        showRightClass: "menu-right",
        showTopClass: "menu-top",
        showBottomClass: "menu-bottom",
        menuOpenClass: "cbp-spmenu-open",
        pushBodyClass: "push-body",
        closeOnClickOutside: true,
		closeOnClickLink: true
    };
})(jQuery);
